import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProgramTypeForm } from "../../../components/program/ProgramTypeForm";
import { workflowService } from "@/services/features/WorkflowService";
import { useAuth } from "@/contexts/AuthContext";
import { useErrorHandler } from "@/hooks/useErrorHandler";

const AddProgramType = () => {
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const { handleError, handleSuccess } = useErrorHandler();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: { programName: string; applicableStatusIds: string[] }) => {
    if (!user?.id || !token) {
      handleError(new Error("User not authenticated"));
      return;
    }

    setIsLoading(true);
    try {
      // Convert string IDs to numbers for the API
      const numericIds = data.applicableStatusIds.map(id => parseInt(id));
      
      await workflowService.createProgramType(
        user.id,
        data.programName,
        numericIds,
        token
      );

      handleSuccess("Program type created successfully");
      navigate("/admin/program-type");
    } catch (error: any) {
      handleError(error, "Failed to create program type");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/admin/program-type");
  };

  return (
    <ProgramTypeForm
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isEdit={false}
      isLoading={isLoading}
    />
  );
};

export default AddProgramType;